module.exports = __webpack_public_path__ + "static/media/avatar-1.0b0fd4f8.svg";